import React from 'react';
import { Icon } from 'shared/ui';
import cls from './NoTaskFoundPlaceholder.module.css';
import { useTranslation } from 'react-i18next';

export const NoTaskFoundPlaceholder = () => {
    const { t } = useTranslation();
    return (
        <div className={cls.noTaskFoundPlaceholder}>
            <Icon iconName={'noFoundTasks'} />
            <p>{t('NoTaskFoundPlaceholder.return.p')}</p>
        </div>
    );
};
